import React, { useState, useEffect, useCallback, useContext } from 'react';
import ProductCard from '../../Common/Product/ProductCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Heading from '../Heading';
import PharmacyHeading from '../../Pharmacy/PharmacyHeading';
import { connect, useSelector } from "react-redux";
import * as actions from "../../../actions/service";
import * as user from "../../../actions/user";
import { AuthContext } from '../../../context/AuthContext';
import _ from 'lodash'
import { Link, useHistory } from "react-router-dom"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from '../../../utils/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import arrow from './../../../assets/img/custom/arrow.png'

const timeSlots = [
  { name: '9.00 AM', value: '9.00', disabled: false },
  { name: '9.30 AM', value: '9.30', disabled: false },
  { name: '10.00 AM', value: '10.00', disabled: false },
  { name: '10.30 AM', value: '10.30', disabled: false },
  { name: '11.00 AM', value: '11.00', disabled: false },
  { name: '11.30 AM', value: '11.30', disabled: false },
  { name: '12.00 PM', value: '12.00', disabled: false },
  { name: '12.30 PM', value: '12.30', disabled: false },
  { name: '1.00 PM', value: '13.00', disabled: false },
  { name: '1.30 PM', value: '13.30', disabled: false },
  { name: '2.00 PM', value: '14.00', disabled: false },
  { name: '2.30 PM', value: '14.30', disabled: false },
  { name: '3.00 PM', value: '15.00', disabled: false },
  { name: '3.30 PM', value: '15.30', disabled: false },
  { name: '4.00 PM', value: '16.00', disabled: false },
  { name: '4.30 PM', value: '16.30', disabled: false },
  { name: '5.00 PM', value: '17.00', disabled: false },
  { name: '5.30 PM', value: '17.30', disabled: false },
  { name: '6.00 PM', value: '18.00', disabled: false },
  { name: '6.30 PM', value: '18.30', disabled: false },
  { name: '7.00 PM', value: '19.00', disabled: false },
  { name: '7.30 PM', value: '19.30', disabled: false },
  { name: '8.00 PM', value: '20.00', disabled: false },
  { name: '8.30 PM', value: '20.30', disabled: false },
  { name: '9.00 PM', value: '21.00', disabled: false },
  { name: '9.30 PM', value: '21.30', disabled: false }
]

const TodayDeal = (props) => {
  const { t, i18n } = useTranslation();
  const [myCart, setMycart] = useState(props.cartArray);
  const [isLoading, SetIsLoading] = useState(true);
  const { logout, getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
  const authUser = getAuthUser()
  const history = useHistory()
  const isAuthentic = isAuthenticated()

  const [slots, setSlots] = useState(timeSlots);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(new Date());
  const [currentService, setCurrentService] = useState({});

  let products = useSelector((state) => props.data);
  let settings = {
    arrows: true,
    dots: false,
    margin: 30,
    infinite: false,
    speed: 500,
    slidesToShow: props.title === 'Deals of The Month' ? 2 : 4,
    slidesToScroll: 1,
    responsive: [{

      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    },
    ]
  };


  useEffect(() => {
    const onSuccess = () => {
      SetIsLoading(false)
    }
    if (isAuthentic) {
      props.fetchCart(authUser.id)
    }
    console.log('1232333??' + props.title, props.data[0])

    setMycart(props.cartArray)

  }, []);

  useEffect(() => {
    //console.log('11www',myCart)
    //if(isFocused){ 
    if (isAuthentic) {
      onDebounceUpdateUserCart(myCart);
      setMycart(myCart)
    }
    //}
  }, [myCart]);


  const onDebounceUpdateUserCart = useCallback(_.debounce((cart) => {
    const onSuccess = (res) => {

    }

    props.updateUserCart(authUser?.id, {
      cart: cart
    }, onSuccess)

  }, 900), []);


  const onPlus = (serviceID) => {
    if (!isAuthentic) {
      history.push('/login')
      return
    }

    setMycart(myCart.concat([serviceID]))

  };

  const onMinus = (serviceID) => {

    myCart.splice(myCart.findIndex(a => a === serviceID), 1);

    setMycart(_.without(myCart, _.find(myCart, serviceID)))

  };

  useEffect(() => {

    setSelectedSlot("")
    setSlots([])

    API.doctorbooking().getAvailableTimeSlots({
      doctor: currentService.doctorId,
      bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
    })
      .then(res => {

        let booked = res.data
        //console.log('---->1',booked)
        let sl = timeSlots;
        if (new Date(selected).toISOString().split('T')[0] === new Date().toISOString().split('T')[0]) {

          sl.filter((ele, index) => {
            sl[index].disabled = false

            if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
              sl[index].disabled = true
            } else {
              if (booked.includes(ele.value)) {
                sl[index].disabled = true
              }
            }
          })
        } else {
          sl.filter((ele, index) => {
            sl[index].disabled = false
            if (booked.includes(ele.value)) {
              sl[index].disabled = true
            }
          })
        }

        setSlots(sl)
      })
      .catch(err => console.log(err))

  }, [selected]);
  const confirmBooking = () => {
    API.doctorbooking().create({
      doctor: currentService.doctorId,
      services: [currentService.id],
      type: 'treatment',
      customer: authUser.id,
      bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
      bookingTime: selectedSlot,
      status: 'pending',
    })
      .then(res => {
        handleClose()
        Swal.fire({
          title: 'Thank you for booking!',
          text: 'Our customer service agent will call you for appointment confirmation.',
          icon: 'success',
          showConfirmButton: true,

        })

      })
      .catch(err => console.log(err))


  };



  const enableBookAppointmentModal = (service) => {
    if (!isAuthentic) {
      history.push('/login')
      return
    }

    setCurrentService(service)

    setSelectedSlot("")
    setSelected(new Date())

    let sl = timeSlots;
    sl.filter((ele, index) => {
      sl[index].disabled = false

      if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
        sl[index].disabled = true
      }
    })
    setSlots(sl)

    setShow(true);
  }

  const handleClose = () => {
    setShow(false)
    setSelected(new Date())
    setSelectedSlot("")
  };

  return (
    <>
      <section id="to_days_area" className="py-5 slider_arrows_one">
        <div className="container">

          {props.heading === 1 && <Heading heading={props.title} para={props.subheading} />}
          {props.heading === 2 && <PharmacyHeading heading={props.title} hidebooking={props?.hidebooking}/>}

          {!props.isTiles ? <div className="row">
            <div className="col-lg-12">
              <div className="todays_slider">
                <Slider {...settings}>
                  {products.map((data, index) => (
                    <ProductCard data={data} key={index} hideButtons={true} onPlus={() => onPlus(data.id)}
                      onMinus={() => onMinus(data.id)}
                      cartArray={props.cartArray}
                      count={_.countBy(myCart)[data.id]}
                      enableBookAppointmentModal={() => enableBookAppointmentModal(data)}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div> : <div className="row">
            {products.map((data, index) => (

              <div key={index} className="col-xl-6 col-12 ">
              {index===0 || index===1 ?  <div className="row">
                  <div className="col-xl-6 col-12 px-0">
                  <img src={process.env.REACT_APP_IMG_URL + data.image} />
                  </div>
                  <div className="col-xl-6 col-12 text-center px-2 py-xl-0 py-4 my-auto">
                  
                    <h3 className='font-weight-light mb-2 d-block'>{data.title[i18n.language]}</h3>
                    <small className='mb-3'>{data.description[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}<Link to={{
                        pathname: `/treatments/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                            service: data,
                            count: _.countBy(myCart)[data.id],

                            cartArray: props.cartArray
                        }}} className='text-warn font-weight-light ml-2'>{t('knowmore')} <img src={arrow} style={{ height: 10 }} /></Link></small>
                    <br></br>
                    <Link to={{ pathname: `/estore`, state: { type: 'product' } }} className="btn cartbtn btn-sm mt-2">{t('viewall')} {t('services')}</Link>
                  </div>
                </div>: 
                <div className="row">
                  <div className="col-xl-6 col-12 text-center px-2 py-xl-0 py-4 my-auto">
                
                <h3 className='font-weight-light mb-2 d-block'>{data.title[i18n.language]}</h3>
                <small className='mb-3'>{data.description[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}<Link to={{
                        pathname: `/treatments/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                            service: data,
                            count: _.countBy(myCart)[data.id],

                            cartArray: props.cartArray
                        }}} className='text-warn font-weight-light ml-2'>{t('knowmore')} <img src={arrow} style={{ height: 10 }} /></Link></small>
                <br></br>
                <Link to={{ pathname: `/estore`, state: { type: 'product' } }} className="btn cartbtn btn-sm mt-2">{t('viewall')} {t('services')}</Link>
              </div>
                <div className="col-xl-6 col-12 px-0">
                <img src={process.env.REACT_APP_IMG_URL + data.image} />
                </div>
                
              </div>
                }

              </div>

            ))}
          </div>}
        </div>
      </section>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('bookappt')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-lg-6'>


              <div className="form-group">
                <label for="exampleInputEmail1">{t('date')}</label>
                <DatePicker className="btn-block form-control"
                  minDate={new Date()}
                  selected={selected}
                  onChange={(date) => {
                    setSelected(date)

                  }} />

              </div>
            </div>
            <div className='col-lg-6'>
              <div className="form-group">
                <label>{t('time')}</label>

                <select className="form-control" onChange={(e) => setSelectedSlot(e.target.value)}>
                  <option>Choose</option>
                  {slots.map((e, index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
                </select>
              </div>
            </div>
            <div className='col-lg-12'>

              <small className="form-text text-muted">Date & time will be confirmed by our customer service agent</small>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
          <button type="button" className="btn bg-adam" onClick={confirmBooking}>{t('booknow')}</button>
        </Modal.Footer>
      </Modal>
    </>
  )
}


const mapStateToProps = state => ({

  users: state.user.users,
  cart: state.user.cart,
  cartArray: state.user.cartArray
})

const mapActionToProps = {

  update: actions.update,
  updateUser: user.update,
  updateUserCart: user.updateCart,
  fetchCart: user.fetchCart
}

export default connect(mapStateToProps, mapActionToProps)(TodayDeal);
